module.exports = __webpack_public_path__ + "static/media/cmobiler.3e3000d9.png";